import React from 'react';
import { Skeleton } from '../../ui/skeleton';
import { Card, CardContent } from '../../ui/card';

const ListLoadingSkeleton = ({ 
  items = 5,
  showAvatar = false,
  showActions = false,
  showSearch = false,
  showFilters = false,
  className = ""
}) => {
  return (
    <div className={`space-y-4 ${className}`}>
      {/* Search and Filters */}
      {(showSearch || showFilters) && (
        <div className="flex items-center justify-between mb-4">
          {showSearch && (
            <Skeleton className="h-10 w-64" />
          )}
          {showFilters && (
            <div className="flex gap-2">
              <Skeleton className="h-10 w-32" />
              <Skeleton className="h-10 w-32" />
            </div>
          )}
        </div>
      )}
      
      {/* List Items */}
      <div className="space-y-2">
        {[...Array(items)].map((_, index) => (
          <Card key={index} className="bg-white border-slate-200">
            <CardContent className="p-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3 flex-1">
                  {showAvatar && (
                    <Skeleton className="h-10 w-10 rounded-full" />
                  )}
                  <div className="space-y-2 flex-1">
                    <Skeleton className="h-4 w-48" />
                    <Skeleton className="h-3 w-32" />
                  </div>
                </div>
                
                <div className="flex items-center gap-4">
                  {/* Status or Badge */}
                  <Skeleton className="h-6 w-20 rounded-full" />
                  
                  {/* Additional info */}
                  <Skeleton className="h-4 w-24" />
                  
                  {showActions && (
                    <div className="flex gap-1">
                      <Skeleton className="h-8 w-8" />
                      <Skeleton className="h-8 w-8" />
                    </div>
                  )}
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
      
      {/* Load More or Pagination */}
      <div className="flex justify-center pt-4">
        <Skeleton className="h-10 w-32" />
      </div>
    </div>
  );
};

export default ListLoadingSkeleton;